export default {
  unauthorised: '401'
};
